import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { CommonService } from '../../service/common/common.service';
import { NzFormatEmitEvent, NzTreeComponent } from 'ng-zorro-antd/tree';
import { FunctionService } from '../../service/function/function.service';

@Component({
  selector: 'duties-select',
  templateUrl: './duties-select.component.html',
  styleUrls: ['./duties-select.component.less'],
})
export class DutiesSelectComponent implements OnInit {
  @ViewChild('nzTreeComponent', { static: false }) nzTreeComponent!: NzTreeComponent;
  // selectTplIds = ['10020'];

  /**
   * 数据源
   */
  @Input() data: Array<object> = [];
  /**
   * 是否显示 boolean
   */
  @Input() show: boolean = false;
  /**
   * 是否显示模板岗位  默认显示
   */
  @Input() useDutiesTpl: boolean = true;
  @Input() dutiesType: number = 1; // 检索的自定义岗位类型 1全部 2 招聘岗位
  /**
   * 显示模式 string  employee  员工 admin  管理岗员工 depart  部门 duties 岗位
   */
  @Input() model: string = 'employee';
  /**
   * 是否显示自定义岗位
   */
  @Input() showAll: boolean = true;
  /**
   * 选择模式 true  多选 false  单选
   */
  @Input() nzMultiple: boolean = true;
  /**
   * 组织架构
   */
  @Input() structure: Array<object> = [];
  /**
   * 已选择的数据
   * 结构: {key: 1,mobile: "13522279999",title: "苏总",value: 1}
   * key ,title , realKey  type organ_type,path必填
   */
  @Input() checkData: Array<object> = [];
  /**
   * 推荐标题
   */
  @Input() checkTitle: string = '模板岗位';
  @Input() checkTitle2: string = '自定义岗位';
  /**
   * 确认按钮文字
   */
  @Input() sureText: string = '确认';
  /**
   * 取消按钮文字
   */
  @Input() cancelText: string = '取消';

  /**
   * 确定事件
   */
  @Output() sure = new EventEmitter();
  /**
   * 取消事件
   */
  @Output() cancel = new EventEmitter();
  dutiesTplData: Array<object> = []; // 模板岗位数据
  isAll: boolean = false; // 判断tab的类型 true  全部 false 推荐
  selectTplIds: Array<any> = []; // 选择的模板岗位id
  selectData: Array<object> = []; // 选择的岗位信息
  selectIds: Array<any> = []; // 选择的推荐用户的id
  selectResult: Array<object> = []; // 选中数据
  leftSearch: string = ''; // 左侧检索关键字
  leftSearchResult: Array<object> = [];
  rightSearch: string = ''; // 右侧检索关键字
  dutiesData: Array<object> = []; // 处理后的自定义岗位信息
  leftSearchTpl: string = ''; // 检索岗位模板的关键字
  leftSearchDuties: string = ''; // 检索自定义岗位的关键字
  showTplData: Array<any> = []; // 展示的模板岗位
  showDutiesData: Array<any> = []; // 展示的自定义岗位
  tplCheckAll: boolean = false; //  岗位模板是否全选
  dutiesCheckAll: boolean = false; //  检所后的自定义岗位是否全选
  constructor(private common: CommonService, private fun: FunctionService, private ref: ChangeDetectorRef) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] != undefined && this.data != undefined && this.data.length != 0) {
      if (this.useDutiesTpl) {
        this.setDutiesTpl();
      }
      // 遍历处理传入的源数据
      for (const i of this.data) {
        const duties: Array<object> = this.dealData(i['child_node'], i['organ_name']);
        const item = {};
        item['key'] = 'organ_' + i['organ_id'];
        item['realKey'] = i['organ_id'];
        item['title'] = i['organ_name'];
        item['selectable'] = false;
        item['children'] = [];
        item['type'] = 'organ';
        item['expanded'] = true;
        Object.assign(item, i);
        delete item['child_node'];
        delete item['template'];
        item['children'] = [...duties];
        if (duties.length > 0) {
          this.dutiesData.push(item);
        }
      }
    }
    if (changes['checkData'] != undefined && this.checkData.length > 0) {
      this.dealResultShow(); //  如果传入选中数据  则进行回显处理
    }
    if (!this.useDutiesTpl) {
      this.isAll = true;
    }
    if (changes['show']) {
      if (this.show == true) {
        this.dealResultShow();
      } else {
        this.clearSearch();
      }
    }
    console.log(this.dutiesData, this.isAll);
  }

  /**
   * 移除选择到的选项
   * @param item
   * @param index
   */
  delete(item: object): void {
    switch (item['type']) {
      case 'tpl': // 判断操作的是岗位模板
        const _selectTplIds = [...this.selectTplIds];
        if (_selectTplIds.indexOf(item['key']) > -1) {
          _selectTplIds.splice(_selectTplIds.indexOf(item['key']), 1);
          this.fun.deleteObjectItem(this.selectData, 'key', item['key']).then((res) => {
            this.selectData = res;
          });
          this.selectTplIds = [..._selectTplIds];
        }
        break;
      case 'duties': // 如果操作的是自定义岗位
        // 从选择自定义岗位id数组中移除 当前id  并且从已选择数据中移除当前数据
        const _selectIds = [...this.selectIds];
        if (_selectIds.indexOf(item['key']) > -1) {
          _selectIds.splice(_selectIds.indexOf(item['key']), 1);
          this.fun.deleteObjectItem(this.selectData, 'key', item['key']).then((res) => {
            this.selectData = res;
          });
          this.selectIds = [..._selectIds];
        }
        break;
      default:
        break;
    }
    // 校验全选
    this.decisionCheckAll();
  }

  /**
   * 右侧检索
   * @param $event
   */
  setRightSearch($event: any): void {
    this.rightSearch = $event;
  }

  /**
   * 清空所有选择
   */
  clear(): void {
    this.selectTplIds = [...[]];
    this.selectIds = [...[]];
    this.selectData = [...[]];
    // 校验全选
    this.decisionCheckAll();
  }

  /**
   * 输出结果
   */
  putResult(): void {
    this.sure.emit({ event: 'sure', target: this.selectData });
  }

  close(): void {
    this.cancel.emit({ event: 'cancel' });
  }

  /**
   * 处理已选数据的回显
   * @private
   */
  private dealResultShow(): void {
    this.selectData = [...this.checkData];
    const selectIds = [];
    const selectTplIds = [];
    this.checkData.map((item) => {
      if (item['type'] == 'tpl') {
        selectTplIds.push(item['key']);
      } else {
        selectIds.push(item['key']);
      }
    });
    this.selectIds = [...selectIds];
    this.selectTplIds = [...selectTplIds];
    if ((selectTplIds.length == 0 && selectIds.length > 0) || (selectIds.length == 0 && !this.useDutiesTpl)) {
      this.isAll = true;
    } else {
      this.isAll = false;
    }
  }

  /**
   * 处理岗位模板数据
   * @private
   */
  private setDutiesTpl(): void {
    const tplData = [];
    for (const i of this.data) {
      if (i['template'] != undefined && i['template'].length > 0) {
        const item = {};
        item['key'] = 'organ_' + i['organ_id'];
        item['realKey'] = i['organ_id'];
        item['title'] = i['organ_name'];
        item['selectable'] = false;
        item['children'] = [];
        item['type'] = 'organ';
        item['expanded'] = true;
        Object.assign(item, i);
        i['template'].map((tpl) => {
          const tplItem = {};
          tplItem['key'] = 'tpl_' + tpl['templete_job_id'];
          tplItem['realKey'] = tpl['templete_job_id'];
          tplItem['title'] = tpl['job_name'];
          tplItem['isLeaf'] = true;
          tplItem['type'] = 'tpl';
          tplItem['path'] = i['organ_name'] + '/模板岗位';
          Object.assign(tplItem, tpl);
          item['children'].push(tplItem);
        });
        tplData.push(item);
      }
    }
    this.dutiesTplData = [...tplData];
  }

  /**
   * 选择岗位模板
   * @param $event
   */
  checkTpl($event: NzFormatEmitEvent): void {
    const data = $event.node.origin;
    // 判断当前选择数据是否是岗位模板
    if (data['type'] != 'tpl') {
      return;
    }
    let selectTplIds = [...this.selectTplIds];
    let selectData = [...this.selectData];
    if (!this.nzMultiple) {
      // 判断选择模式是否是单选
      if (this.selectIds.length != 0) {
        this.selectIds = [];
        selectData = [];
      }
      selectTplIds = [data.key];
      selectData = [data];
    } else {
      // 判断当前数据是否已经被选中了
      if (this.selectTplIds.indexOf(data.key) == -1) {
        selectTplIds.push(data.key);
        selectData.push(data);
      } else {
        selectTplIds.splice(this.selectTplIds.indexOf(data.key), 1);
        this.selectData.map((item, index) => {
          if (item['key'] == data.key) {
            selectData.splice(index, 1);
          }
        });
      }
    }
    this.selectTplIds = [...selectTplIds];
    this.selectData = [...selectData];
  }

  /**
   * 处理自定义岗位信息
   * @param data
   * @param parentPath
   * @private
   */
  private dealData(data: Array<object>, parentPath: string = ''): any {
    const response: Array<object> = [];
    for (const i of data) {
      const item = {};
      // 判断当前数据类型是否是岗位  organ_type=5
      if (i['organ_type'] == 5) {
        item['key'] = 'duties_' + i['job_id'];
        item['realKey'] = i['job_id'];
        item['type'] = 'duties';
      } else {
        item['key'] = 'organ_' + i['organ_id'];
        item['realKey'] = i['organ_id'];
        item['type'] = 'organ';
        item['selectable'] = false;
      }
      // 设置岗位的全路径
      if (parentPath == '') {
        item['path'] = i['organ_name'];
      } else {
        if (i['child_node'] == undefined || i['child_node'].length == 0) {
          item['path'] = parentPath;
        } else {
          item['path'] = parentPath + '/' + i['organ_name'];
        }
      }
      item['title'] = i['organ_name'];
      delete item['child_node'];
      Object.assign(item, i);
      // 如果存在子数据，则进行递归下一层
      if (i['child_node'] != undefined && i['child_node'].length > 0) {
        item['children'] = this.dealData(i['child_node'], parentPath + '/' + item['title']);
        if (item['children'].length == 0) {
          continue;
        }

        response.push(item);
      } else if (i['organ_type'] == 5) {
        item['isLeaf'] = true;
        response.push(item);
      }
    }
    return response;
  }

  /**
   * 选择岗位信息
   * @param $event
   */
  checkDuties($event: NzFormatEmitEvent): void {
    const data = $event.node.origin;
    if (data['type'] != 'duties') {
      return;
    }
    let selectIds = [...this.selectIds];
    let selectData = [...this.selectData];
    // 判断当前选择模式是否是单选
    if (!this.nzMultiple) {
      if (this.selectIds.length != 0) {
        this.selectIds = [];
        selectData = [];
      }
      selectIds = [data.key];
      selectData = [data];
    } else {
      // 判断当前数据是否已经被选中了
      if (this.selectIds.indexOf(data.key) == -1) {
        selectIds.push(data.key);
        selectData.push(data);
      } else {
        selectIds.splice(this.selectIds.indexOf(data.key), 1);
        this.selectData.map((item, index) => {
          if (item['key'] == data.key) {
            selectData.splice(index, 1);
          }
        });
      }
    }
    this.selectIds = [...selectIds];
    this.selectData = [...selectData];
  }

  /**
   * 清除检索数据
   */
  clearSearch(): void {
    if (!this.isAll) {
      this.leftSearchTpl = '';
      this.showTplData = [];
    } else {
      this.leftSearchDuties = '';
      this.showDutiesData = [];
    }
  }

  /**
   * 检索模板岗位信息
   */
  searchTpl($event: any): void {
    this.leftSearchTpl = $event.target.value;
    if (this.leftSearchTpl == '') {
      this.showTplData = [];
      return;
    }
    const _showTplData = [];
    for (const organ of this.dutiesTplData) {
      for (const tpl of organ['children']) {
        if (tpl['title'].indexOf(this.leftSearchTpl) > -1) {
          _showTplData.push(tpl);
        }
      }
    }
    this.showTplData = [..._showTplData];
  }

  /**
   * 全选岗位模板
   * @param $event
   */
  allTplCheck($event: any): void {
    const _selectTplIds = [...this.selectTplIds];
    const _selectData = [...this.selectData];
    if (!$event) {
      for (const i of this.showTplData) {
        if (_selectTplIds.indexOf(i['key']) > -1) {
          _selectTplIds.splice(_selectTplIds.indexOf(i['key']), 1);
          _selectData.forEach((item, index) => {
            if (item['key'] == i['key']) {
              _selectData.splice(index, 1);
            }
          });
        }
      }
    } else {
      for (const i of this.showTplData) {
        if (_selectTplIds.indexOf(i['key']) == -1) {
          _selectTplIds.push(i['key']);
          _selectData.push(i);
        }
      }
    }
    this.selectTplIds = [..._selectTplIds];
    this.selectData = [..._selectData];
    this.decisionCheckAll();
  }

  /**
   * 选择岗位模板
   * @param key
   * @param index
   * @param $event
   */
  selectTpl(key: any, index: number, $event: any): void {
    // 判断是选中还是取消
    const _selectTplIds = [...this.selectTplIds];
    const _selectData = [...this.selectData];
    // 需要取消
    if (_selectTplIds.indexOf(key) > -1) {
      _selectTplIds.splice(_selectTplIds.indexOf(key), 1);
      _selectData.forEach((item, i) => {
        if (item['key'] == key) {
          _selectData.splice(i, 1);
        }
      });
    } else {
      // 需要选中
      _selectTplIds.push(key);
      _selectData.push(this.showTplData[index]);
    }
    this.selectTplIds = [..._selectTplIds];
    this.selectData = [..._selectData];
    this.decisionCheckAll();
  }

  /**
   * 全选建搜出的自定义岗位
   * @param $event
   */
  allDutiesCheck($event: any): void {
    const _selectIds = [...this.selectIds];
    const _selectData = [...this.selectData];
    // 判断是全选还是取消全选
    if (!$event) {
      this.showDutiesData.forEach((item) => {
        if (_selectIds.indexOf(item['key']) > -1) {
          _selectIds.splice(_selectIds.indexOf(item['key']), 1);
          _selectData.forEach((data, index) => {
            if (data['key'] == item['key']) {
              _selectData.splice(index, 1);
            }
          });
        }
      });
    } else {
      this.showDutiesData.forEach((item) => {
        if (_selectIds.indexOf(item['key']) == -1) {
          _selectIds.push(item['key']);
          _selectData.push(item);
        }
      });
    }
    this.selectIds = [..._selectIds];
    this.selectData = [..._selectData];
    this.decisionCheckAll();
  }

  /**
   * 单选自定义岗位
   * @param key
   * @param index
   * @param $event
   */
  selectDuties(key: any, index: number, $event: any): void {
    const _selectIds = [...this.selectIds];
    const _selectData = [...this.selectData];
    // 判定当前岗位是否是选中状态
    if (_selectIds.indexOf(key) > -1) {
      _selectIds.splice(_selectIds.indexOf(key), 1);
      _selectData.forEach((item, i) => {
        if (item['key'] == key) {
          _selectData.splice(i, 1);
        }
      });
    } else {
      _selectIds.push(key);
      _selectData.push(this.showDutiesData[index]);
    }
    this.selectIds = [..._selectIds];
    this.selectData = [..._selectData];
    // 检验是否全选
    this.decisionCheckAll();
  }

  /**
   * 检索自定义岗位
   */
  searchDuties($event: any): void {
    this.leftSearchDuties = $event.target.value;
    // 判断检索关键字是否为空
    if (this.leftSearchDuties == '') {
      this.showDutiesData = [];
    } else {
      this.getDuties().then((res) => {
        if (res.length == 0) {
          this.showDutiesData = [];
        } else {
          const _showDutiesData = [];
          res.forEach((item) => {
            _showDutiesData.push({
              key: 'duties_' + item['job_id'],
              realKey: item['job_id'],
              title: item['job_name'],
              type: 'duties',
              path: item['organ_all_path'],
              ...item,
            });
          });
          this.showDutiesData = [..._showDutiesData];
        }
        this.decisionCheckAll();
      });
    }
  }

  private decisionCheckAll(): void {
    // 判断推荐数据是否已经全选
    const _tplCheckAll = this.showTplData.every((item) => {
      return this.selectTplIds.indexOf(item['key']) > -1;
    });
    this.tplCheckAll = _tplCheckAll;
    const _dutiesCheckAll = this.showDutiesData.every((item) => {
      return this.selectIds.indexOf(item['key']) > -1;
    });
    this.dutiesCheckAll = _dutiesCheckAll;
  }

  /**
   * 检索自定义岗位
   */
  async getDuties(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.common.ajax({
        url: this.dutiesType == 1 ? 'organ/getJobTemplateTreeByJobName' : 'headhuntingTool/getJobTreeByJobName',
        data: { job_name: this.leftSearchDuties },
        loading: true,
        success: (res) => {
          resolve(res);
        },
      });
    });
  }
}
